import * as authTypes from './authTypes'

const initialState = {}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        /* Get OTP data */
        case authTypes.GET_OTP_DATA_SUCCESS:
            return {
                ...state,
                ...action.payload
            }
        /* Clear OTP data */
        case authTypes.CLEAR_OTP_DATA_SUCCESS:
            return initialState
        default:
            return state
    }
}

export default authReducer
